import ErrorPage from '../../pages/other/ErrorPage/ErrorPage';
import PublicLayout from '../layouts/PublicLayout/PublicLayout';
import { RouteObject, Navigate } from 'react-router-dom';
import { lazyComponent } from './lazy';
import SigninPage from '@pages/other/SigninPage/SigninPage';
import ForcedSessionSigninPage from '@pages/other/SigninPage/ForcedSessionSigninPage';

const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <PublicLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <SigninPage />,
        // @fixme: need to fix
        // lazy: () => {
        //   return lazyComponent(
        //     import('../../pages/other/SigninPage/SigninPage'),
        //   );
        // },
      },
      {
        path: '*',
        element: <SigninPage />,
      },
      {
        // Forced session sign-in route for QA testers.
        // selectAuthPath() detects this pathname and returns 'session',
        // causing a /bff/login redirect regardless of rollout percentage.
        // Kill switch still overrides this and falls back to pkce.
        path: '/session-signin',
        element: <ForcedSessionSigninPage />,
      },
      {
        path: '/signin-oidc',
        lazy: () =>
          lazyComponent(
            import('@pages/other/SigninCallbackPage/SigninCallbackPage'),
          ),
      },
      {
        path: '/signout-callback-oidc',
        lazy: () =>
          lazyComponent(
            import('@pages/other/SignoutCallbackPage/SignoutCallbackPage'),
          ),
      },
      {
        path: '/forbidden',
        element: <Navigate to='/' replace />,
      },
    ],
  },
];

export default publicRoutes;
